export default __webpack_public_path__ + "static/about_nfte-fb52037462c4a2e6fdf4670942333eda.mp4";